import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function useServiceTemplates(params?: Record<string, string>) {
  return useQuery({
    queryKey: ['service-templates', params],
    queryFn: () => apiClient.get('/service-templates', params),
  });
}

export function useCreateServiceTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string; description?: string; unitPrice: number; category?: string }) =>
      apiClient.post('/service-templates', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['service-templates'] });
    },
  });
}

export function useUpdateServiceTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: string; name?: string; description?: string; unitPrice?: number; category?: string; isActive?: boolean }) =>
      apiClient.put(`/service-templates/${id}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['service-templates'] });
    },
  });
}

export function useDeleteServiceTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`/service-templates/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['service-templates'] });
    },
  });
}
